import styled from "styled-components";
// import theme from "../../styledTheme/styledTheme";

export const FixeInfoStyled = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  top: 0;
  /* background-color: blue; */
  width: ${({ theme }) => theme.fixedMenuWidth};
  padding: 25px 25px 25px 36px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
